import styled from 'styled-components';
import { Form } from '../Form';

export const SForm = styled(Form)`
  textarea {
    resize: none;
  }
`;
